// extracted by mini-css-extract-plugin
export var divider = "_ty-0";
export var systemMessage = "_ty-1";